import React from 'react';
import ChatApp from './components/ChatApp';

function App() {
  return (
    <div className="App">
      <ChatApp />
    </div>
  );
}

export default App;